import { useRouterState } from "@tanstack/react-router";
import { useMemo, useEffect } from "react";
import { pushEventToGTM } from "../utils/gtm";
import { getWhiteLabel } from "../utils/white-label";

const stripLocale = (pathname: string) =>
  pathname.replace(/^\/v2\/[a-z]{2}(_[A-Z]{2})?/, "") || "/";

const resolveVirtualUrl = (
  prefix: string,
  pathnameMap: [string, string][] | undefined,
  localeFreePathname: string,
): string => {
  const prefixed = `${prefix}${localeFreePathname}`;
  if (!pathnameMap?.length) return prefixed;
  const map = Object.fromEntries(pathnameMap);
  return map[prefixed] ?? prefixed;
};

export const VirtualPageView = () => {
  const { tagManagerKey, tagManagerUrlPrefix, tagManagerPathnameMap } =
    getWhiteLabel();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const stablePathnameMap = useMemo(
    () => tagManagerPathnameMap,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(tagManagerPathnameMap)],
  );

  useEffect(() => {
    if (!tagManagerKey || !tagManagerUrlPrefix) return;

    const virtualUrl = resolveVirtualUrl(
      tagManagerUrlPrefix,
      stablePathnameMap,
      stripLocale(pathname),
    );

    pushEventToGTM({ event: "virtualPageView", virtualUrl });
  }, [pathname, tagManagerKey, tagManagerUrlPrefix, stablePathnameMap]);

  return undefined;
};
